import { getAll } from '@/services/api';
import {
  appendNavigationFlagMenuItems,
  buildCommercialBillingSectionData,
  findCommercialBillingSection,
  parseNavigationCanCreateCustomer,
  parseNavigationCommercialScope,
  parseNavigationIsAutomyOwner,
} from '@/components/SiderMenu/utils/sessionNavigation';
import {
  SESSION_TYPES,
  getCurrentSession,
  isActivePortalContext,
} from '@/utils/infrastructure/auth';

const isProcessPortalRuntime = (portal) => {
  if (typeof window !== 'undefined' && window.location.pathname.startsWith('/p/')) return true;
  if (getCurrentSession()?.type === SESSION_TYPES.PORTAL) return true;
  // Leftover DVA/session portal config after a failed /p/ visit must not
  // skip Automy `me/navigation` (commercial billing / owner menus).
  return !!portal && isActivePortalContext();
};

const initialState = {
  channelActorKind: null,
  isAutomyOwner: null,
  commercialScope: null,
  navigationLoaded: false,
  commercialBillingSectionTitle: null,
  commercialBillingMenuItems: [],
  commercialBillingApiRoutes: {},
};

const SessionNavigationModel = {
  namespace: 'sessionNavigation',
  state: initialState,

  effects: {
    *fetchNavigation(_, { call, put, select }) {
      const portal = yield select((state) => state.companyPortal?.portal);
      if (isProcessPortalRuntime(portal)) return;

      try {
        const response = yield call(getAll, { route: 'me/navigation' });
        yield put({ type: 'setNavigation', payload: response });
      } catch (e) {
        yield put({ type: 'reset', payload: { navigationLoaded: true } });
      }
    },
  },

  reducers: {
    setNavigation(state, { payload }) {
      const section = findCommercialBillingSection(payload?.sections);
      const built = buildCommercialBillingSectionData(section);
      const isAutomyOwner = parseNavigationIsAutomyOwner(payload);
      const canCreateCustomer = parseNavigationCanCreateCustomer(payload);
      const commercialScope = parseNavigationCommercialScope(payload);
      const { menuItems, apiRoutes } = appendNavigationFlagMenuItems(
        section,
        built.menuItems,
        built.apiRoutes,
        { isAutomyOwner, canCreateCustomer, commercialScope },
      );

      return {
        ...state,
        channelActorKind: payload?.channelActorKind ?? null,
        isAutomyOwner,
        commercialScope,
        navigationLoaded: true,
        // Keep the API section title. Flag-only items (e.g. financial administration)
        // still require the commercial section the hub already receives under global scope.
        commercialBillingSectionTitle: section?.title ?? null,
        commercialBillingMenuItems: menuItems,
        commercialBillingApiRoutes: apiRoutes,
      };
    },

    reset(_state, { payload } = {}) {
      return {
        ...initialState,
        navigationLoaded: Boolean(payload?.navigationLoaded),
      };
    },
  },
};

export default SessionNavigationModel;
